<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="h-30"></div>
    <div class="facility-heading">View Materials</div>
    <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">Materials Details</span>
          <span class="reviewstatus-{{materialStatus}}">{{materialStatus.toUpperCase()}}</span>
        </div>
        <div class="review-form-fileds">
          <span class="label">ID</span>
          <span class="answers">{{viewmaterial.materialId}}</span>
        </div>
        <div class="review-form-fileds">
          <span class="label" >Material Name</span>
          <span class="answers">{{viewmaterial.materialName}}</span>

        </div>

        <div class="review-form-fileds">
          <span class="label">Type</span>
          <span class="answers">{{viewmaterial.materialType}}</span>
          <span></span>
        </div>

        <div class="review-form-fileds">
          <span class="label">Language</span>
          <span class="answers">{{viewmaterial.language}}</span>
          <span></span>
        </div>

        <div class="review-form-fileds">
          <span class="label">Tags</span>
          <span class="answers">
            <ul class="stacked-list">
              @for (tag of tagNames; track tag) {
                <li>
                  {{ tag }}
                </li>
              }
            </ul>
          </span>
          <span></span>
        </div>

        <div class="review-form-fileds">
          <span class="label">Material</span>
          <span class="answers">{{viewmaterial.materialFileName}}
            <a (click)="downloadFile()"><img src="assets/filelinkicon.svg" class="materialdownloadfile"/></a>&nbsp;
          </span>
          <span></span>
        </div>
        <div class="h-30"></div>

        <div class="review-form-fileds" [hidden]="!viewmaterial.isReplaced">
          <span class="label"> Replacement Material</span>
          <span class="answers">{{viewmaterial.replacementMaterialName}}

            <a (click)="downloadReplacementFile()"><img src="assets/filelinkicon.svg" height="30px" width="30px"></a>
            <br>
              {{viewmaterial.replacementMaterialId}}
            </span>
            <span></span>
          </div>
          <div class="mb-10"></div>

          <div class="tableContents" [hidden]="courseList.length==0">
            <h6>Associated Courses <app-information-popup [information]="information"></app-information-popup></h6>
            <div >
              <ng-container #courseContainer *ngTemplateOutlet="courseTable; context: {data: courseList, headerVisible: true}"></ng-container>
              <ng-template #courseTable let-data="  data" let-headerVisible="headerVisible">
                <app-no-results #noResults></app-no-results>

                <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Course Id">Id</th>
                    <td mat-cell *matCellDef="let course">
                      {{course.courseId}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name">Course Name</th>
                    <td mat-cell *matCellDef="let course">
                      <a href="/view-course/{{course.id}}">{{course.courseName}}</a>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="program">
                    <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Program">Programs</th>
                    <td mat-cell *matCellDef="let course">
                      <ul class="stacked-list">
                        @for (program of course.programs; track program) {
                          <li>
                            {{ program }}
                          </li>
                        }
                      </ul>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="enrollment">
                    <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by enrollment">Language</th>
                    <td mat-cell *matCellDef="let course">
                      {{course.language}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Status">Status</th>
                    <td mat-cell *matCellDef="let course">
                      <app-status-bubble [status]="course.status"></app-status-bubble>
                    </td>
                  </ng-container>
                  @if (headerVisible) {
                    <tr mat-header-row *matHeaderRowDef="coursecolumnsToDisplay" class="tableHeader"></tr>
                  }
                  <tr mat-row *matRowDef="let tags; columns: coursecolumnsToDisplay"></tr>
                </table>
              </ng-template>
            </div>
          </div>

          <div class="form-buttons" [hidden]="!showeditbutton">
            <button class="submit-form-button" [hidden]="!viewmaterial.isEditEnabled" (click)="navigate('edit-material/'+materialid)">Edit Material</button>
            <button class="delete-button" [hidden]="!viewmaterial.isDeleteEnabled" (click)="deleteMaterial()">Delete Material</button>
          </div>

        </div>
      </form>
      <app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
    </div>
  </div>

  <app-footer></app-footer>

  @if (modalOpen | async) {
    <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
    [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
  }
